<template>
  <form
    autocomplete="off"
    @submit.prevent="$emit('submit')"
  >
    <div class="mx-auto flex flex-col justify-center mb-8 w-[330px]">
      <div class="w-[160px] mx-auto">
        <img
          :src="displaySrc"
          class="rounded-full w-full h-[160px] object-cover"
        >

        <div class="w-full flex items-center justify-between mb-2 mt-2">
          <FileUploadButton
            class="text-editor-btn-text !text-base !font-semibold !py-1 !px-0 !min-w-0 hover:underline"
            accept=".png, .jpg, .jpeg, .webp"
            text="Change"
            @file-selected="handleFileSelected"
          />

          <button
            type="button"
            class="text-editor-btn-text !text-base !font-semibold !py-1 !px-0 !min-w-0 hover:underline"
            @click="clearImage"
          >
            Remove
          </button>
        </div>
      </div>

      <p class="font-medium text-center text-chrome text-base leading-[18px]">
        A Profile image of the person, it's best if the picture has the same length and height
      </p>
    </div>

    <TextInput
      v-model.trim="formData.name"
      v-focus
      :label="`${uploadSubject}'s Name`"
      class="max-w-[385px]"
      @keydown.enter.prevent="$emit('submit')"
    />

    <TextInput
      v-model.trim="formData.title"
      :label="`${uploadSubject}'s Title`"
      class="max-w-[385px]"
      @keydown.enter.prevent="$emit('submit')"
    />
  </form>
</template>

<script setup>
import { computed } from 'vue';
import PlaceholderUserImg from '@/assets/images/icons/placeholder-user.svg';
import { TextInput } from '@/components/form-inputs';
import { FileUploadButton } from '@/components/buttons';

defineEmits(['submit']);

const selectedFile = defineModel('selectedFile');
const formData = defineModel('formData');

const props = defineProps({
  currentPhoto: {
    type: [String, File, Blob, Object],
    default: null,
  },
  uploadSubject: String,
});

const displaySrc = computed(() => {
  if (selectedFile.value) {
    return URL.createObjectURL(selectedFile.value);
  }

  if (formData.value.removePhoto) {
    return PlaceholderUserImg;
  }

  if (props.currentPhoto) {
    if (props.currentPhoto instanceof File || props.currentPhoto instanceof Blob) {
      return URL.createObjectURL(props.currentPhoto);
    }
    return props.currentPhoto;
  }

  return PlaceholderUserImg;
});

const handleFileSelected = (file) => {
  selectedFile.value = file;
  formData.value.removePhoto = false;
};

const clearImage = () => {
  selectedFile.value = null;
  formData.value.removePhoto = true;
};
</script>
